// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadingPreference_container__bK6Hm","spinner":"ReadingPreference_spinner__DAbUN"};